<template>
  <div class="div-table-itens">
    <TelaCheia v-model="tela_cheia" titulo="Dashboard">
      <v-data-table
        v-model="fornecedores_selecionado"
        :headers="HEADERS_COMPUTED"
        :items="ITENS_COMPUTADOS"
        :fixed-header="true"
        :hide-default-footer="false"
        :items-per-page="15"
        class="elevation-2 font-resp-tabela table-full-screen"
        :search="search"
        :item-key="cardSelecionado.item_key"
        :item-class="corItemFornecedorAtivo"
        :show-select="cardSelecionado.exibir_selecao && !ativar_exibicao_grupo_fornecedor"
        :height="tela_cheia ? 'calc(100vh - 177px)' : 'calc(100vh - 435px)'"
      >
        <template v-slot:top>
          <div class="d-flex align-center px-2 py-2">
            <span v-text="cardSelecionado.titulo" class="title font-weight-regular" />

            <span v-if="exibirIconMudarVisao()" class="font-15 pl-1 pt-1">
              <template v-if="visaoDashboard == 1">- Visão gerencial quantitativa</template>
              <template v-else>- Visão gerencial financeira</template>
            </span>

            <v-tooltip right v-if="exibirIconMudarVisao()">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="mudarVisaoDashboard()"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                >
                  <v-icon>mdi-swap-horizontal</v-icon>
                </v-btn>
              </template>

              <span>
                {{visaoDashboard == 2 ? 'Mudar visão Dashboard para visão Quantitativa' : 'Mudar visão Dashboard para visão Gerencial/Financeira'}}
              </span>
            </v-tooltip>

            <CriarGrupoDeAnaliseDeCompras
              v-show="fornecedores_selecionado && fornecedores_selecionado.length > 0"
              v-model="fornecedores_selecionado"
              class="ml-3"
              @cadastro-com-sucesso="cardSelecionado.metodo(page, grupoCompra)"
            />

            <v-switch
              v-if="cardSelecionado.exibir_selecao"
              v-model="ativar_exibicao_grupo_fornecedor"
              class="ml-3"
              color="#A51B32"
              label="Mostrar Grupos?"
              hide-details
            >
              <template #label>
                <span class="pl-2">Exibir grupos de análise</span>
              </template>
            </v-switch>

            <v-spacer></v-spacer>

            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisa"
              dense
              single-line
              hide-details
              clearable
              v-lazy-input:debounce="500"
              class="pr-4 pl-auto"
              style="max-width: 475px"
            ></v-text-field>

            <v-btn v-show="!tela_cheia" title="Maximizar" icon @click="tela_cheia = !tela_cheia">
              <v-icon small>$Maximixar</v-icon>
            </v-btn>
            <v-btn title="Exportar para Excel" icon @click="exportarParaExcel()">
              <v-icon>
                $Excel
              </v-icon>
            </v-btn>
          </div>
        </template>
        <!-- SOMATORIO DE COLUNAS -->
        <template slot="body.prepend">
          <!-- TOTALIZADOR DE FISAO ESTOQUE -->
          <tr
            v-if="
              !verificaExistencia('descricaoStatus') &&
              (visaoDashboard == 1 || visao_gerencial == 'N')
            "
            class="totalizadores"
          >
            <th v-if="cardSelecionado.exibir_selecao && !ativar_exibicao_grupo_fornecedor">
              <v-btn icon disabled>
                <v-icon>mdi-checkbox-blank-outline</v-icon>
              </v-btn>
            </th>
            <th>#</th>
            <th>TOTALIZADORES</th>
            <th v-if="verificaExistencia('qtde_fornecedores')">
              {{ Helpers.formatarValor(sumField("qtde_fornecedores")) }}
            </th>
            <th v-if="verificaExistencia('qtde_geral_itens')">
              {{ sumField("qtde_geral_itens") }}
            </th>
            <th v-if="verificaExistencia('qtde_itens_excesso')">
              {{ sumField("qtde_itens_excesso") }}
            </th>
            <th v-if="verificaExistencia('qtde_itens_ok')">
              {{ sumField("qtde_itens_ok") }}
            </th>
            <th v-if="verificaExistencia('qtde_itens_ressuprir')">
              {{ cards.produtosComprar.total }}
            </th>
            <th v-if="verificaExistencia('qtd_produtos_com_venda_futura')">
              {{ sumField("qtd_produtos_com_venda_futura") }}
            </th>
            <th v-if="verificaExistencia('qtde_itens_transito')">
              {{ sumField("qtde_itens_transito") }}
            </th>

            <th v-if="verificaExistencia('total_pendente')">
              {{ Helpers.formatarValorMonetario(sumField("total_pendente")) }}
            </th>

            <th v-if="verificaExistencia('qtde_dias_estoque')">
              -
            </th>
            <th v-if="verificaExistencia('eficiencia')">-</th>
            <th v-if="verificaExistencia('total_ressuprir')">
              {{ Helpers.formatarValorMonetario(sumField("total_ressuprir")) }}
            </th>
            <th v-if="verificaExistencia('total_estoque')">
              {{ Helpers.formatarValorMonetario(sumField("total_estoque")) }}
            </th>
            <th v-if="verificaExistencia('data_solicitacao')">-</th>
            <th v-if="verificaExistencia('data_previsao')">-</th>
            <th v-if="verificaExistencia('id_solicitacao')">-</th>
            <th v-if="verificaExistencia('qtde_itens')">
              {{ Helpers.formatarValor(sumField("qtde_itens")) }}
            </th>
            <th v-if="verificaExistencia('qtde_itens_pendentes')">
              {{ Helpers.formatarValor(sumField("qtde_itens_pendentes")) }}
            </th>
            <th v-if="verificaExistencia('total_itens')">
              {{ Helpers.formatarValorMonetario(sumField("total_itens")) }}
            </th>
            <th></th>
          </tr>
          <!-- TOTALIZADOR DE FISAO FINANCEIRA -->
          <tr
            v-if="
              !verificaExistencia('descricaoStatus') &&
              visaoDashboard == 2 &&
              visao_gerencial == 'S'
            "
            class="totalizadores"
          >
            <th v-if="cardSelecionado.exibir_selecao && !ativar_exibicao_grupo_fornecedor">
              <v-btn icon disabled>
                <v-icon>mdi-checkbox-blank-outline</v-icon>
              </v-btn>
            </th>
            <th>#</th>
            <th>TOTALIZADORES</th>
            <th v-if="verificaExistencia('qtde_fornecedores')">
              {{ Helpers.formatarValor(sumField("qtde_fornecedores")) }}
            </th>
            <th v-if="verificaExistencia('qtde_geral_itens')">
              {{ sumField("qtde_geral_itens") }}
            </th>
            <th v-if="verificaExistencia('total_estoque')">
              {{ Helpers.formatarValorMonetario(sumField("total_estoque")) }}
            </th>
            <th v-if="verificaExistencia('markup_medio')">
              {{
                Helpers.formatarValor(
                  (
                    (sumField("total_estoque_venda") / sumField("total_estoque") -
                      1) *
                    100
                  ).toFixed(2)
                )
              }}%
            </th>
            <th v-if="verificaExistencia('total_estoque_venda')">
              {{
                Helpers.formatarValorMonetario(sumField("total_estoque_venda"))
              }}
            </th>
            <th v-if="verificaExistencia('media_venda_trimestre_anterior')">
              {{
                Helpers.formatarValorMonetario(
                  sumField("media_venda_trimestre_anterior")
                )
              }}
            </th>
            <th v-if="verificaExistencia('projecao_venda_mensal')">
              {{
                Helpers.formatarValorMonetario(sumField("projecao_venda_mensal"))
              }}
            </th>
            <th v-if="verificaExistencia('projecao_rentabilidade_mensal')">
              {{
                Helpers.formatarValorMonetario(
                  sumField("projecao_rentabilidade_mensal")
                )
              }}
            </th>
            <th v-if="verificaExistencia('eficiencia')">-</th>
            <th v-if="verificaExistencia('total_ressuprir')">
              {{ Helpers.formatarValorMonetario(sumField("total_ressuprir")) }}
            </th>
            <th v-if="verificaExistencia('data_solicitacao')">-</th>
            <th v-if="verificaExistencia('data_previsao')">-</th>
            <th v-if="verificaExistencia('id_solicitacao')">-</th>
            <th v-if="verificaExistencia('qtde_itens')">
              {{ Helpers.formatarValor(sumField("qtde_itens")) }}
            </th>
            <th v-if="verificaExistencia('qtde_itens_pendentes')">
              {{ Helpers.formatarValor(sumField("qtde_itens_pendentes")) }}
            </th>
            <th v-if="verificaExistencia('total_itens')">
              {{ Helpers.formatarValorMonetario(sumField("total_itens")) }}
            </th>
            <th></th>
          </tr>
        </template>
        <template v-slot:item.razao_social="{ item }">
          <div :title="item.ativo === 'S' ? 'Fornecedor está ativo': 'Fornecedor não está ativo'">
            {{ item.razao_social }}
          </div>
        </template>
        <template v-slot:item.descricaoStatus="{ item }">
          <div>
            <span
              class="dot"
              :style="{ backgroundColor: item.descricaoStatus.cor }"
            ></span>
            {{ item.descricaoStatus.descricao }}
          </div>
        </template>
        <template v-slot:item.qtde_geral_itens="{ item }">
          <div class="qtdeProdutosTotal">
            <div
              title="Abrir Tela de Exportação de Relatório Qtde. Produtos Total"
              @click="
                enviarDadosParaDialogRelatorio(
                  cardsDialogRelatorios.produtosTotal,
                  item
                )
              "
              style="cursor: help"
            >
              {{ item.qtde_geral_itens }}
              <v-menu
                v-if="visaoDashboard == 2 && visao_gerencial == 'S'"
                top
                transition="slide-x-transition"
                :offset-x="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    style="margin-left: 3px; font-size: 11pt"
                    title="Outras Categorias de Itens"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item>
                    Produtos Excesso: {{ item.qtde_itens_excesso }}&nbsp;
                    <v-icon
                      title="Abrir Tela de Exportação de Relatório Produtos Excesso"
                      @click="
                        enviarDadosParaDialogRelatorio(
                          cardsDialogRelatorios.produtosExcesso,
                          item
                        )
                      "
                      small
                    >mdi-open-in-new</v-icon
                    >
                  </v-list-item>
                  <v-list-item>
                    Produtos Adequado: {{ item.qtde_itens_ok }}&nbsp;
                    <v-icon
                      title="Abrir Tela de Exportação de Relatório Produtos Ok"
                      @click="
                        enviarDadosParaDialogRelatorio(
                          cardsDialogRelatorios.produtosOk,
                          item
                        )
                      "
                      small
                    >mdi-open-in-new</v-icon
                    >
                  </v-list-item>
                  <v-list-item>
                    Produtos a Comprar: {{ item.qtde_itens_ressuprir }}&nbsp;
                    <v-icon
                      title="Abrir Tela de Exportação de Relatório Produtos a Comprar"
                      @click="
                        enviarDadosParaDialogRelatorio(
                          cardsDialogRelatorios.produtosAComprar,
                          item
                        )
                      "
                      small
                    >mdi-open-in-new</v-icon
                    >
                  </v-list-item>
                  <v-list-item>
                    Produtos em Trânsito: {{ item.qtde_itens_transito }}&nbsp;
                    <v-icon
                      title="Abrir Tela de Exportação de Relatório Produtos em Trânsito"
                      @click="
                        enviarDadosParaDialogRelatorio(
                          cardsDialogRelatorios.produtosEmTransito,
                          item
                        )
                      "
                      small
                    >mdi-open-in-new</v-icon
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </template>
        <template v-slot:item.total_pendente="{ item }">{{
            Helpers.formatarValorMonetario(item.total_pendente, item.moeda)
          }}</template>
        <template v-slot:item.total_ressuprir="{ item }">{{
            Helpers.formatarValorMonetario(item.total_ressuprir, item.moeda)
          }}</template>
        <template v-slot:item.total_estoque="{ item }">{{
            Helpers.formatarValorMonetario(item.total_estoque, item.moeda)
          }}</template>
        <template v-slot:item.valor_unitario="{ item }">{{
            Helpers.formatarValorMonetario(item.valor_unitario)
          }}</template>
        <template v-slot:item.custo_unitario="{ item }">{{
            Helpers.formatarValorMonetario(item.custo_unitario)
          }}</template>
        <template v-slot:item.total_itens="{ item }">{{
            Helpers.formatarValorMonetario(item.total_itens)
          }}</template>
        <template v-slot:item.icon_eye="{ item }">
          <v-btn icon @click="getPedido(item)">
            <v-icon>{{ item.icon_eye }}</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.icon_compra="{ item }">
          <div class="d-flex justify-end">
            <template v-if="item.grupo_analise_fornecedores">
              <CriarGrupoDeAnaliseDeCompras
                :grupo_analise_para_edicao="item"
                icon
                @cadastro-com-sucesso="cardSelecionado.metodo(page, grupoCompra)"
              >
                <template #botao-ativador="{ativador}">
                  <v-btn icon @click="ativador">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
              </CriarGrupoDeAnaliseDeCompras>
            </template>

            <v-btn icon @click="getFornComprador(item)">
              <v-icon>{{ item.icon_compra }}</v-icon>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.icon_analise="{ item }">
          <v-btn icon @click="getFornListaCompradorGrupo(item)">
            <v-icon>{{ item.icon_analise }}</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.icon_analise_segmentos="{ item }">
          <v-btn icon @click="getListaSegmentosComprador(item)">
            <v-icon>{{ item.icon_analise_segmentos }}</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.qtde_itens="{ item }">
          {{ Helpers.formatarValor(item.qtde_itens) }}
        </template>
        <template v-slot:item.qtde_itens_pendentes="{ item }">
          {{ Helpers.formatarValor(item.qtde_itens_pendentes) }}
        </template>
        <template v-slot:item.qtde_dias_estoque="{ item }">
          <DialogDiasEstoque :item="item" />
        </template>
        <template v-slot:item.markup_medio="{ item }">
          <div>{{ parseFloat(item.markup_medio) }}%</div>
        </template>
        <template v-slot:item.total_estoque_venda="{ item }">
          {{ Helpers.formatarValorMonetario(item.total_estoque_venda) }}
        </template>
        <template v-slot:item.projecao_venda_mensal="{ item }">
          {{ Helpers.formatarValorMonetario(item.projecao_venda_mensal) }}
        </template>
        <template v-slot:item.projecao_rentabilidade_mensal="{ item }">
          {{ Helpers.formatarValorMonetario(item.projecao_rentabilidade_mensal) }}
        </template>
        <template v-slot:item.media_venda_trimestre_anterior="{ item }">
          {{
            Helpers.formatarValorMonetario(item.media_venda_trimestre_anterior)
          }}
        </template>
        <template v-slot:item.eficiencia="{ item }">
          <span
            title="Eficiência do Comprador"
            @click="buscarEficienciaComprador(item)"
            style="cursor: pointer"
          >{{ item.eficiencia }}</span
          >
        </template>
        <!-- VISAO ESTOQUE -->
        <template v-slot:item.qtde_fornecedores="{ item }">
          <div>{{ item.qtde_fornecedores }}</div>
        </template>
        <template v-slot:item.qtde_itens_excesso="{ item }">
          <div
            @click="
              enviarDadosParaDialogRelatorio(
                cardsDialogRelatorios.produtosExcesso,
                item
              )
            "
            style="cursor: help"
            title="Abrir Tela de Exportação de Relatório Produtos Excesso"
          >
            {{ item.qtde_itens_excesso }}
          </div>
        </template>
        <template v-slot:item.qtde_itens_ok="{ item }">
          <div
            @click="
              enviarDadosParaDialogRelatorio(
                cardsDialogRelatorios.produtosOk,
                item
              )
            "
            style="cursor: help"
            title="Abrir Tela de Exportação de Relatório Produtos Ok"
          >
            {{ item.qtde_itens_ok }}
          </div>
        </template>
        <template v-slot:item.qtde_itens_ressuprir="{ item }">
          <div
            @click="
              enviarDadosParaDialogRelatorio(
                cardsDialogRelatorios.produtosAComprar,
                item
              )
            "
            style="cursor: help"
            title="Abrir Tela de Exportação de Relatório Produtos a Comprar"
          >
            {{ item.qtde_itens_ressuprir }}
          </div>
        </template>

        <template #item.qtd_produtos_com_venda_futura="{ item }">
          {{ Helpers.formatarValor(item.qtd_produtos_com_venda_futura) }}
        </template>

        <template v-slot:item.qtde_itens_transito="{ item }">
          <div
            @click="
              enviarDadosParaDialogRelatorio(
                cardsDialogRelatorios.produtosEmTransito,
                item
              )
            "
            style="cursor: help"
            title="Abrir Tela de Exportação de Relatório Produtos em Trânsito"
          >
            {{ item.qtde_itens_transito }}
          </div>
        </template>
      </v-data-table>
    </TelaCheia>

    <!-- Modal com tela cheia com dados do grid -->
<!--    <v-layout>-->
<!--      <v-dialog-->
<!--        v-model="dialogGrid"-->
<!--        fullscreen-->
<!--        hide-overlay-->
<!--        transition="dialog-bottom-transition"-->
<!--      >-->
<!--        <v-card>-->
<!--          <v-toolbar dark color="#042333">-->
<!--            <v-btn icon dark @click="dialogGrid = false">-->
<!--              <v-icon>mdi-close</v-icon>-->
<!--            </v-btn>-->
<!--            <v-toolbar-title>{{ cardSelecionado.titulo }}</v-toolbar-title>-->
<!--          </v-toolbar>-->
<!--          <v-data-table-->
<!--            :headers="cardSelecionado.headers[indexHeader()]"-->
<!--            :items="$store.state.tabela.items.data"-->
<!--            :fixed-header="true"-->
<!--            :hide-default-footer="false"-->
<!--            :items-per-page="15"-->
<!--            class="elevation-3 gridPrincipal table-full-screen table-full-screen-responsiva"-->
<!--            :search="search"-->
<!--            item-key="idproduto"-->
<!--            style="margin: 0px 10px 0px 10px"-->
<!--          >-->
<!--            <template v-slot:top>-->
<!--              <v-toolbar flat color="white">-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-text-field-->
<!--                  v-model="search"-->
<!--                  append-icon="mdi-magnify"-->
<!--                  label="Pesquisa"-->
<!--                  outlined-->
<!--                  dense-->
<!--                  single-line-->
<!--                  hide-details-->
<!--                  clearable-->
<!--                  v-lazy-input:debounce="500"-->
<!--                  class="pl-5 pr-5"-->
<!--                  style="max-width: 550px"-->
<!--                ></v-text-field>-->
<!--                <v-btn-->
<!--                  color="#2979FF"-->
<!--                  style="color: #fff"-->
<!--                  title="Exportar Para Excel"-->
<!--                  @click="exportarDadosGrid()"-->
<!--                >-->
<!--                  <v-icon>mdi-file-export</v-icon>Exportar-->
<!--                </v-btn>-->
<!--              </v-toolbar>-->
<!--            </template>-->
<!--            &lt;!&ndash; SOMATORIO DE COLUNAS &ndash;&gt;-->
<!--            <template slot="body.prepend">-->
<!--              &lt;!&ndash; TOTALIZADOR DE FISAO ESTOQUE &ndash;&gt;-->
<!--              <tr-->
<!--                v-if="-->
<!--                  !verificaExistencia('descricaoStatus') &&-->
<!--                  (visaoDashboard == 1 || visao_gerencial == 'N')-->
<!--                "-->
<!--                class="totalizadores"-->
<!--              >-->
<!--                <th>#</th>-->
<!--                <th>TOTALIZADORES</th>-->
<!--                <th v-if="verificaExistencia('qtde_fornecedores')">-->
<!--                  {{ Helpers.formatarValor(sumField("qtde_fornecedores")) }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_geral_itens')">-->
<!--                  {{ sumField("qtde_geral_itens") }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_itens_excesso')">-->
<!--                  {{ sumField("qtde_itens_excesso") }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_itens_ok')">-->
<!--                  {{ sumField("qtde_itens_ok") }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_itens_ressuprir')">-->
<!--                  {{ sumField("qtde_itens_ressuprir") }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_itens_transito')">-->
<!--                  {{ sumField("qtde_itens_transito") }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('eficiencia')">-</th>-->
<!--                <th v-if="verificaExistencia('total_ressuprir')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(sumField("total_ressuprir"))-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('total_estoque')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(sumField("total_estoque"))-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('data_solicitacao')">-</th>-->
<!--                <th v-if="verificaExistencia('data_previsao')">-</th>-->
<!--                <th v-if="verificaExistencia('id_solicitacao')">-</th>-->
<!--                <th v-if="verificaExistencia('qtde_itens')">-->
<!--                  {{ Helpers.formatarValor(sumField("qtde_itens")) }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_itens_pendentes')">-->
<!--                  {{ Helpers.formatarValor(sumField("qtde_itens_pendentes")) }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('total_itens')">-->
<!--                  {{ Helpers.formatarValorMonetario(sumField("total_itens")) }}-->
<!--                </th>-->
<!--                <th></th>-->
<!--              </tr>-->
<!--              &lt;!&ndash; TOTALIZADOR DE FISAO FINANCEIRA &ndash;&gt;-->
<!--              <tr-->
<!--                v-if="-->
<!--                  !verificaExistencia('descricaoStatus') &&-->
<!--                  visaoDashboard == 2 &&-->
<!--                  visao_gerencial == 'S'-->
<!--                "-->
<!--                class="totalizadores"-->
<!--              >-->
<!--                <th>#</th>-->
<!--                <th>TOTALIZADORES</th>-->
<!--                <th v-if="verificaExistencia('qtde_fornecedores')">-->
<!--                  {{ Helpers.formatarValor(sumField("qtde_fornecedores")) }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_geral_itens')">-->
<!--                  {{ sumField("qtde_geral_itens") }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('total_estoque')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(sumField("total_estoque"))-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('markup_medio')">-->
<!--                  {{-->
<!--                    Helpers.formatarValor(-->
<!--                      (-->
<!--                        (sumField("total_estoque_venda") /-->
<!--                          sumField("total_estoque") - -->
<!--                          1) *-->
<!--                        100-->
<!--                      ).toFixed(2)-->
<!--                    )-->
<!--                  }}%-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('total_estoque_venda')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(-->
<!--                      sumField("total_estoque_venda")-->
<!--                    )-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('media_venda_trimestre_anterior')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(-->
<!--                      sumField("media_venda_trimestre_anterior")-->
<!--                    )-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('projecao_venda_mensal')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(-->
<!--                      sumField("projecao_venda_mensal")-->
<!--                    )-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('projecao_rentabilidade_mensal')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(-->
<!--                      sumField("projecao_rentabilidade_mensal")-->
<!--                    )-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('eficiencia')">-</th>-->
<!--                <th v-if="verificaExistencia('total_ressuprir')">-->
<!--                  {{-->
<!--                    Helpers.formatarValorMonetario(sumField("total_ressuprir"))-->
<!--                  }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('data_solicitacao')">-</th>-->
<!--                <th v-if="verificaExistencia('data_previsao')">-</th>-->
<!--                <th v-if="verificaExistencia('id_solicitacao')">-</th>-->
<!--                <th v-if="verificaExistencia('qtde_itens')">-->
<!--                  {{ Helpers.formatarValor(sumField("qtde_itens")) }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('qtde_itens_pendentes')">-->
<!--                  {{ Helpers.formatarValor(sumField("qtde_itens_pendentes")) }}-->
<!--                </th>-->
<!--                <th v-if="verificaExistencia('total_itens')">-->
<!--                  {{ Helpers.formatarValorMonetario(sumField("total_itens")) }}-->
<!--                </th>-->
<!--                <th></th>-->
<!--              </tr>-->
<!--            </template>-->
<!--            <template v-slot:item.descricaoStatus="{ item }">-->
<!--              <p>-->
<!--                <span-->
<!--                  class="dot"-->
<!--                  :style="{ backgroundColor: item.descricaoStatus.cor }"-->
<!--                ></span>-->
<!--                {{ item.descricaoStatus.descricao }}-->
<!--              </p>-->
<!--            </template>-->
<!--            <template v-slot:item.qtde_geral_itens="{ item }">-->
<!--              <div class="qtdeProdutosTotal">-->
<!--                <div-->
<!--                  title="Abrir Tela de Exportação de Relatório Qtde. Produtos Total"-->
<!--                  @click="-->
<!--                    enviarDadosParaDialogRelatorio(-->
<!--                      cardsDialogRelatorios.produtosTotal,-->
<!--                      item-->
<!--                    )-->
<!--                  "-->
<!--                  style="cursor: help; display: contents"-->
<!--                >-->
<!--                  {{ item.qtde_geral_itens }}-->
<!--                </div>-->
<!--                <v-menu-->
<!--                  v-if="visaoDashboard == 2 && visao_gerencial == 'S'"-->
<!--                  top-->
<!--                  transition="slide-x-transition"-->
<!--                  :offset-x="true"-->
<!--                >-->
<!--                  <template v-slot:activator="{ on, attrs }">-->
<!--                    <v-icon-->
<!--                      v-bind="attrs"-->
<!--                      v-on="on"-->
<!--                      style="margin-left: 3px; font-size: 11pt"-->
<!--                      title="Outras Categorias de Itens"-->
<!--                    >-->
<!--                      mdi-information-outline-->
<!--                    </v-icon>-->
<!--                  </template>-->
<!--                  <v-list>-->
<!--                    <v-list-item>-->
<!--                      Produtos Excesso: {{ item.qtde_itens_excesso }}&nbsp;-->
<!--                      <v-icon-->
<!--                        title="Abrir Tela de Exportação de Relatório Produtos Excesso"-->
<!--                        @click="-->
<!--                          enviarDadosParaDialogRelatorio(-->
<!--                            cardsDialogRelatorios.produtosExcesso,-->
<!--                            item-->
<!--                          )-->
<!--                        "-->
<!--                        small-->
<!--                      >mdi-open-in-new</v-icon-->
<!--                      >-->
<!--                    </v-list-item>-->
<!--                    <v-list-item>-->
<!--                      Produtos Adequado: {{ item.qtde_itens_ok }}&nbsp;-->
<!--                      <v-icon-->
<!--                        title="Abrir Tela de Exportação de Relatório Produtos Ok"-->
<!--                        @click="-->
<!--                          enviarDadosParaDialogRelatorio(-->
<!--                            cardsDialogRelatorios.produtosOk,-->
<!--                            item-->
<!--                          )-->
<!--                        "-->
<!--                        small-->
<!--                      >mdi-open-in-new</v-icon-->
<!--                      >-->
<!--                    </v-list-item>-->
<!--                    <v-list-item>-->
<!--                      Produtos a Comprar: {{ item.qtde_itens_ressuprir }}&nbsp;-->
<!--                      <v-icon-->
<!--                        title="Abrir Tela de Exportação de Relatório Produtos a Comprar"-->
<!--                        @click="-->
<!--                          enviarDadosParaDialogRelatorio(-->
<!--                            cardsDialogRelatorios.produtosAComprar,-->
<!--                            item-->
<!--                          )-->
<!--                        "-->
<!--                        small-->
<!--                      >mdi-open-in-new</v-icon-->
<!--                      >-->
<!--                    </v-list-item>-->
<!--                    <v-list-item>-->
<!--                      Produtos em Trânsito: {{ item.qtde_itens_transito }}&nbsp;-->
<!--                      <v-icon-->
<!--                        title="Abrir Tela de Exportação de Relatório Produtos em Trânsito"-->
<!--                        @click="-->
<!--                          enviarDadosParaDialogRelatorio(-->
<!--                            cardsDialogRelatorios.produtosEmTransito,-->
<!--                            item-->
<!--                          )-->
<!--                        "-->
<!--                        small-->
<!--                      >mdi-open-in-new</v-icon-->
<!--                      >-->
<!--                    </v-list-item>-->
<!--                  </v-list>-->
<!--                </v-menu>-->
<!--              </div>-->
<!--            </template>-->
<!--            <template v-slot:item.total_ressuprir="{ item }">{{-->
<!--                Helpers.formatarValorMonetario(item.total_ressuprir)-->
<!--              }}</template>-->
<!--            <template v-slot:item.total_estoque="{ item }">{{-->
<!--                Helpers.formatarValorMonetario(item.total_estoque)-->
<!--              }}</template>-->
<!--            <template v-slot:item.valor_unitario="{ item }">{{-->
<!--                Helpers.formatarValorMonetario(item.valor_unitario)-->
<!--              }}</template>-->
<!--            <template v-slot:item.custo_unitario="{ item }">{{-->
<!--                Helpers.formatarValorMonetario(item.custo_unitario)-->
<!--              }}</template>-->
<!--            <template v-slot:item.total_itens="{ item }">{{-->
<!--                Helpers.formatarValorMonetario(item.total_itens)-->
<!--              }}</template>-->
<!--            <template v-slot:item.icon_eye="{ item }">-->
<!--              <v-btn icon @click="getPedido(item)">-->
<!--                <v-icon>{{ item.icon_eye }}</v-icon>-->
<!--              </v-btn>-->
<!--            </template>-->
<!--            <template v-slot:item.icon_compra="{ item }">-->
<!--              <v-btn icon @click="getFornComprador(item)">-->
<!--                <v-icon>{{ item.icon_compra }}</v-icon>-->
<!--              </v-btn>-->
<!--            </template>-->
<!--            <template v-slot:item.icon_analise="{ item }">-->
<!--              <v-btn icon @click="getFornListaCompradorGrupo(item)">-->
<!--                <v-icon>{{ item.icon_analise }}</v-icon>-->
<!--              </v-btn>-->
<!--            </template>-->
<!--            <template v-slot:item.icon_analise_segmentos="{ item }">-->
<!--              <v-btn icon @click="getListaSegmentosComprador(item)">-->
<!--                <v-icon>{{ item.icon_analise_segmentos }}</v-icon>-->
<!--              </v-btn>-->
<!--            </template>-->
<!--            <template v-slot:item.qtde_fornecedores="{ item }">-->
<!--              <div>{{ item.qtde_fornecedores }}</div>-->
<!--            </template>-->
<!--            <template v-slot:item.qtde_itens="{ item }">-->
<!--              {{ Helpers.formatarValor(item.qtde_itens) }}-->
<!--            </template>-->
<!--            <template v-slot:item.qtde_itens_pendentes="{ item }">-->
<!--              {{ Helpers.formatarValor(item.qtde_itens_pendentes) }}-->
<!--            </template>-->
<!--            <template v-slot:item.markup_medio="{ item }">-->
<!--              <div>{{ parseFloat(item.markup_medio) }}%</div>-->
<!--            </template>-->
<!--            <template v-slot:item.total_estoque_venda="{ item }">-->
<!--              {{ Helpers.formatarValorMonetario(item.total_estoque_venda) }}-->
<!--            </template>-->
<!--            <template v-slot:item.projecao_venda_mensal="{ item }">-->
<!--              {{ Helpers.formatarValorMonetario(item.projecao_venda_mensal) }}-->
<!--            </template>-->
<!--            <template v-slot:item.projecao_rentabilidade_mensal="{ item }">-->
<!--              {{-->
<!--                Helpers.formatarValorMonetario(-->
<!--                  item.projecao_rentabilidade_mensal-->
<!--                )-->
<!--              }}-->
<!--            </template>-->
<!--            <template v-slot:item.media_venda_trimestre_anterior="{ item }">-->
<!--              {{-->
<!--                Helpers.formatarValorMonetario(-->
<!--                  item.media_venda_trimestre_anterior-->
<!--                )-->
<!--              }}-->
<!--            </template>-->
<!--            <template v-slot:item.eficiencia="{ item }">-->
<!--              <span-->
<!--                title="Eficiência do Comprador"-->
<!--                @click="buscarEficienciaComprador(item)"-->
<!--                style="cursor: pointer"-->
<!--              >{{ item.eficiencia }}</span-->
<!--              >-->
<!--            </template>-->
<!--            &lt;!&ndash; VISAO ESTOQUE &ndash;&gt;-->
<!--            <template v-slot:item.qtde_itens_excesso="{ item }">-->
<!--              <div-->
<!--                @click="-->
<!--                  enviarDadosParaDialogRelatorio(-->
<!--                    cardsDialogRelatorios.produtosExcesso,-->
<!--                    item-->
<!--                  )-->
<!--                "-->
<!--                style="cursor: help"-->
<!--                title="Abrir Tela de Exportação de Relatório Produtos Excesso"-->
<!--              >-->
<!--                {{ item.qtde_itens_excesso }}-->
<!--              </div>-->
<!--            </template>-->
<!--            <template v-slot:item.qtde_itens_ok="{ item }">-->
<!--              <div-->
<!--                @click="-->
<!--                  enviarDadosParaDialogRelatorio(-->
<!--                    cardsDialogRelatorios.produtosOk,-->
<!--                    item-->
<!--                  )-->
<!--                "-->
<!--                style="cursor: help"-->
<!--                title="Abrir Tela de Exportação de Relatório Produtos Ok"-->
<!--              >-->
<!--                {{ item.qtde_itens_ok }}-->
<!--              </div>-->
<!--            </template>-->
<!--            <template v-slot:item.qtde_itens_ressuprir="{ item }">-->
<!--              <div-->
<!--                @click="-->
<!--                  enviarDadosParaDialogRelatorio(-->
<!--                    cardsDialogRelatorios.produtosAComprar,-->
<!--                    item-->
<!--                  )-->
<!--                "-->
<!--                style="cursor: help"-->
<!--                title="Abrir Tela de Exportação de Relatório Produtos a Comprar"-->
<!--              >-->
<!--                {{ item.qtde_itens_ressuprir }}-->
<!--              </div>-->
<!--            </template>-->
<!--            <template v-slot:item.qtde_itens_transito="{ item }">-->
<!--              <div-->
<!--                @click="-->
<!--                  enviarDadosParaDialogRelatorio(-->
<!--                    cardsDialogRelatorios.produtosEmTransito,-->
<!--                    item-->
<!--                  )-->
<!--                "-->
<!--                style="cursor: help"-->
<!--                title="Abrir Tela de Exportação de Relatório Produtos em Trânsito"-->
<!--              >-->
<!--                {{ item.qtde_itens_transito }}-->
<!--              </div>-->
<!--            </template>-->
<!--          </v-data-table>-->
<!--        </v-card>-->
<!--      </v-dialog>-->
<!--    </v-layout>-->

    <!-- Modal do pedido -->
    <v-dialog
      v-model="dialogPedido"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#042333">
          <v-btn icon dark @click="dialogPedido = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalhes do pedido</v-toolbar-title>
        </v-toolbar>

        <v-layout align-center class="pa-3">
          <v-flex xs8>
            <h3>{{ infoPedido.razao_social }}</h3>
          </v-flex>
          <v-flex xs4 class="text-lg-right">
            Qtde. Itens: {{ Helpers.formatarValor(infoPedido.qtdeItens) }}
          </v-flex>
        </v-layout>
        <v-layout align-center class="pl-3 pr-3">
          <v-flex xs8>Pedido #{{ infoPedido.numero }}</v-flex>
          <v-flex xs4 class="text-lg-right">
            Total: {{ Helpers.formatarValorMonetario(infoPedido.valorTotal) }}
          </v-flex>
        </v-layout>
        <v-layout align-center class="pa-3">
          <v-flex xs2 class="text-lg-left">
            <h4 style="color: #042333">Produtos</h4>
          </v-flex>
          <v-flex xs8 class="text-lg-right"></v-flex>
          <v-flex xs2 class="text-lg-right"></v-flex>
        </v-layout>
        <v-data-table
          :headers="headersTabelaCarrinho"
          :items="itensTabelaCarrinho"
          :items-per-page="-1"
          :fixed-header="true"
          height="calc(100vh - 250px)"
          class="elevation-2 titulo-tabela-top font-resp-tabela table-full-screen"
          item-key="idproduto"
          style="margin: 0px 10px 0px 10px"
        >
          <!-- SOMATORIO DE COLUNAS -->
          <template slot="body.prepend">
            <tr class="totalizadores">
              <th>#</th>
              <th>TOTALIZADORES</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>
                {{
                  Helpers.formatarValor(sumField("qtde", itensTabelaCarrinho))
                }}
              </th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_entregue", itensTabelaCarrinho)
                  )
                }}
              </th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_pendente", itensTabelaCarrinho)
                  )
                }}
              </th>
            </tr>
          </template>
          <template v-slot:item="props">
            <tr
              :class="
                parseFloat(props.item.qtde) !=
                parseFloat(props.item.qtde_entregue)
                  ? 'alerta'
                  : ''
              "
            >
              <td>{{ props.item.idproduto }}</td>
              <td class="text-left">{{ props.item.descricao_produto }}</td>
              <td>{{ props.item.data_solicitacao }}</td>
              <td>{{ props.item.data_previsao }}</td>
              <td>{{ props.item.unidade_medida }}</td>
              <td>
                {{ Helpers.formatarValor(props.item.qtde) }}
              </td>
              <td>
                {{ Helpers.formatarValor(props.item.qtde_entregue) }}
              </td>
              <td>
                {{ Helpers.formatarValor(props.item.qtde_pendente) }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <!-- Modal do Lista de Fornecedores em Ressuprir -->
    <DialogFornecedoresRessuprir
      v-model="dialogListaFornecedor"
      :desserts_tabela="itensListaFornecedor"
      :comprador="{ nome: comprador.nome_completo, id: comprador.codigo }"
    />
    <!-- <v-dialog
      v-model="dialogListaFornecedor"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#042333">
          <v-btn icon dark @click="dialogListaFornecedor = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Lista de Fornecedores em Ressuprimento</v-toolbar-title>

          <v-spacer />

          <v-btn color="primary" small @click="exportarFornecedoresEmRessuprimento">
            <v-icon left>mdi-file-export</v-icon>
            exportar
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headersListaFornecedor"
          :items="itensListaFornecedor"
          :items-per-page="-1"
          :fixed-header="true"
          class="elevation-0 titulo-tabela-top altura-responsiva-grid-fullscreen altura-responsiva-grid-fullscreen table-full-screen"
          style="cursor: pointer; margin: 0px 10px 0px 10px"
          :calculate-widths="true"
          :search="search_comp"
          item-key="id"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title
              ><h5>
                Comprador(a): {{ comprador.nome_completo }}
              </h5></v-toolbar-title
              >
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                label="Pesquisa"
                append-icon="mdi-magnify"
                outlined
                dense
                clearable
                single-line
                hide-details
                v-model="search_comp"
                v-lazy-input:debounce="500"
                style="max-width: 550px"
              ></v-text-field>
            </v-toolbar>
          </template>

          <template slot="body.prepend">
            <tr class="totalizadores">
              <th>#</th>
              <th>TOTALIZADORES</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_geral_itens", itensListaFornecedor)
                  )
                }}
              </th>
              <th>-</th>
              <th>{{ Helpers.formatarValorMonetario(sumField("faturamento_ultimos_tres_meses", itensListaFornecedor))}}</th>
              <th>{{ Helpers.formatarValorMonetario(sumField("qtde_excesso", itensListaFornecedor))}}</th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_itens_ok", itensListaFornecedor)
                  )
                }}
              </th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_itens_ressuprir", itensListaFornecedor)
                  )
                }}
              </th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_itens_transito", itensListaFornecedor)
                  )
                }}
              </th>
              <th>{{ Helpers.formatarValorMonetario(sumField("estoque_parado", itensListaFornecedor)) }}</th>
              <th>
                {{
                  Helpers.formatarValorMonetario(
                    sumField("total_ressuprir", itensListaFornecedor)
                  )
                }}
              </th>
              <th></th>
            </tr>
          </template>
          <template v-slot:item="props">
            <tr
              @click="getFornComprador(props.item, 2)"
              :class="{ selected_row: props.item.id === selectedId }"
            >
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.razao_social }}</td>
              <td>{{ props.item.data_ultima_analise }}</td>
              <td>{{ props.item.qtde_dias_ultima_analise == 0 ? "Hoje" : props.item.qtde_dias_ultima_analise }}</td>
              <td>
                <v-badge color="white" overlap v-if="props.item.cotacao > 0">
                  <template v-slot:badge>
                    <h4 style="color: #000">
                      {{ props.item.qtde_item_cotacao }}
                    </h4>
                  </template>
                  <v-icon title="Compra em processo de Cotação"
                  >mdi-phone-log</v-icon
                  >
                </v-badge>
              </td>
              <td>{{ props.item.dias_em_cotacao }}</td>
              <td>{{ props.item.qtde_geral_itens }}</td>
              <td>{{ deParaClassificacaoCriticidade(props.item.abc_venda) }}</td>
              <td>{{ Helpers.formatarValorMonetario(props.item.faturamento_ultimos_tres_meses) }}</td>
              <td>{{ Helpers.formatarValorMonetario(props.item.qtde_excesso) }}</td>
              <td>{{ props.item.qtde_itens_ok }}</td>
              <td>{{ props.item.qtde_itens_ressuprir }}</td>
              <td>{{ props.item.qtde_itens_transito }}</td>
              <td>{{ Helpers.formatarValorMonetario(props.item.estoque_parado) }}</td>
              <td>
                {{ Helpers.formatarValorMonetario(props.item.total_ressuprir) }}
              </td>
              <td>
                <v-btn icon>
                  <v-icon>{{ props.item.icon_compra }}</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog> -->
    <!-- Modal do Lista de Segmentos a Ressuprir -->
    <v-dialog
      v-model="dialogListaSegmentosComprador"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#042333">
          <v-btn icon dark @click="dialogListaSegmentosComprador = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Lista de Segmentos em Ressuprimento</v-toolbar-title>
        </v-toolbar>
        <v-data-table
          :headers="headersListaSegmentosComprador"
          :items="itensListaSegmentosComprador"
          :items-per-page="9999"
          :fixed-header="true"
          class="elevation-0 titulo-tabela-top altura-responsiva-grid-fullscreen table-full-screen"
          style="cursor: pointer; margin: 0px 10px 0px 10px"
          :calculate-widths="true"
          :search="search_comp"
          item-key="id"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title
              ><h5>
                Segmentos/Categoria: {{ segmento.nome_completo }}
              </h5></v-toolbar-title
              >
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                label="Pesquisa"
                append-icon="mdi-magnify"
                outlined
                dense
                clearable
                single-line
                hide-details
                v-model="search_comp"
                v-lazy-input:debounce="500"
                style="max-width: 550px"
              ></v-text-field>
            </v-toolbar>
          </template>

          <!-- SOMATORIO DE COLUNAS -->
          <template slot="body.prepend">
            <tr class="totalizadores">
              <th>#</th>
              <th>TOTALIZADORES</th>
              <th>-</th>
              <th>-</th>
              <th>-</th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_geral_itens", itensListaSegmentosComprador)
                  )
                }}
              </th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField("qtde_itens_ok", itensListaSegmentosComprador)
                  )
                }}
              </th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField(
                      "qtde_itens_ressuprir",
                      itensListaSegmentosComprador
                    )
                  )
                }}
              </th>
              <th v-if="existe_produtos_com_venda_futura">
                {{Helpers.formatarValor(sumField("qtd_produtos_com_venda_futura", itensListaSegmentosComprador)) }}
              </th>
              <th>
                {{
                  Helpers.formatarValor(
                    sumField(
                      "qtde_itens_transito",
                      itensListaSegmentosComprador
                    )
                  )
                }}
              </th>
              <th>
                {{
                  Helpers.formatarValorMonetario(
                    sumField("total_ressuprir", itensListaSegmentosComprador)
                  )
                }}
              </th>
              <th></th>
            </tr>
          </template>
          <template v-slot:item="props">
            <tr
              @click="getSegmentoComprador(props.item, 3)"
              :class="{ selected_row: props.item.id === selectedId }"
            >
              <td>{{ props.item.idfornecedor }}</td>
              <td>{{ props.item.razao_social }}</td>
              <td>{{ props.item.nome_completo }}</td>
              <td>
                <v-badge color="white" overlap v-if="props.item.cotacao > 0">
                  <template v-slot:badge>
                    <h4 style="color: #000">
                      {{ props.item.qtde_item_cotacao }}
                    </h4>
                  </template>
                  <v-icon title="Compra em processo de Cotação"
                  >mdi-phone-log</v-icon
                  >
                </v-badge>
              </td>
              <td>{{ props.item.dias_em_cotacao }}</td>
              <td>{{ props.item.qtde_geral_itens }}</td>
              <td>{{ props.item.qtde_itens_ok }}</td>
              <td>{{ props.item.qtde_itens_ressuprir }}</td>
              <td v-if="existe_produtos_com_venda_futura">{{ props.item.qtd_produtos_com_venda_futura }}</td>
              <td>{{ props.item.qtde_itens_transito }}</td>
              <td>
                {{ Helpers.formatarValorMonetario(props.item.total_ressuprir) }}
              </td>
              <td>
                <v-btn icon>
                  <v-icon>{{ props.item.icon_compra }}</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogEficienciaComprador"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#042333">
          <v-btn icon dark @click="fecharDialogEficienciaComprador()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Eficiência do Comprador -
            {{ moneMes[new Date().getMonth()].concat(" de ").concat(new Date().getFullYear()) }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-2">
          <h3>{{ comprador.codigo }} - {{ comprador.nome_completo }}</h3>
          <v-layout align-center>
            <v-flex xs4 style="text-align: center">
              <v-progress-linear
                :value="eficiencia.qualidade_est"
                color="#0174DF"
                height="25"
                style="color: #fff"
              >
                Qualidade do Estoque:
                {{ parseFloat(eficiencia.qualidade_est) | numeral("0.00") }}%
              </v-progress-linear>
              *
              <v-progress-linear
                :value="eficiencia.eficienciaCompra"
                color="#0174DF"
                height="25"
                style="color: #fff"
              >
                Momento de Compra:
                {{ parseFloat(eficiencia.eficienciaCompra) | numeral("0.00") }}%
              </v-progress-linear>
              =
              <v-progress-linear
                :value="(eficiencia.eficienciaCompra * eficiencia.qualidade_est) / 100"
                color="#043554"
                height="25"
                style="color: #fff"
                :title="`(${Helpers.formatarValorComCasas(eficiencia.eficienciaCompra, 2)} * ${Helpers.formatarValorComCasas(eficiencia.qualidade_est, 2)}) / 100 = ${Helpers.formatarValorComCasas((eficiencia.eficienciaCompra * eficiencia.qualidade_est) / 100, 2)}`"
              >
                Eficiência do Comprador:
                {{ parseFloat((eficiencia.eficienciaCompra * eficiencia.qualidade_est) / 100) | numeral("0.00") }}%
              </v-progress-linear>
            </v-flex>
            <v-flex xs4>
              <chart-torta
                v-if="dialogEficienciaComprador"
                class="altura-grafico-eficiencia"
                title="Análise Compras do Grupo"
                :data="eficiencia.geral"
                :categories="eficiencia.status"
                :cores="coresStatusPercepcao"
                @dataPointIndex="dataPointIndex = $event"
              ></chart-torta>
            </v-flex>
            <v-flex xs4>
              <chart-torta
                v-if="dialogEficienciaComprador"
                class="altura-grafico-eficiencia"
                title="Análise Compras do Comprador"
                :data="eficiencia.comprador"
                :categories="eficiencia.status"
                :cores="coresStatusPercepcao"
                @dataPointIndex="dataPointIndex = $event"
              ></chart-torta>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12>
              <chart-column
                v-if="dialogEficienciaComprador"
                class="altura-grafico-eficiencia"
                title="Análise Comparativa Grupo/Comprador"
                :colors="eficiencia.colors"
                :data="eficiencia.column"
                :categories="eficiencia.status"
                @dataPointIndex="dataPointIndex = $event"
              ></chart-column>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ABRE O DIALOG DE EXPORTAÇÃO DE RELATORIOS -->
    <dialog-relatorios
      :cardRelatorio="cardRelatoriosSelecionado"
      @defaultCard="
        cardRelatoriosSelecionado = $event;
        dataPointIndex = {};
      "
    ></dialog-relatorios>
  </div>
</template>

<script>
import CompraAPI from "./../../api/compra";
import DashboardAPI from "./../../api/dashboard";
import { mapGetters } from "vuex";
import dialogRelatorios from "../layout/dialogRelatorios";
import chartColumn from "./../layout/ChartColumn";
import chartTorta from "./../layout/ChartTorta";
import $axios from '../../api/api.js'
import CriarGrupoDeAnaliseDeCompras from "./fornecedor/CriarGrupoDeAnaliseDeCompras";
import TelaCheia from "../utils/TelaCheia.vue";
import DialogDiasEstoque from "./ComponentesTabela/DiasEstoque/DialogDiasEstoque.vue";
import DialogFornecedoresRessuprir from "./Fornecedores/DialogFornecedoresRessuprir.vue";

export default {
  props: ["cardSelecionado", "cards"],

  components: { CriarGrupoDeAnaliseDeCompras, dialogRelatorios, chartColumn, chartTorta, TelaCheia, DialogDiasEstoque, DialogFornecedoresRessuprir },

  data() {
    return {
      existe_produtos_com_venda_futura: localStorage.existe_produtos_com_venda_futura === 'S',
      ativar_exibicao_grupo_fornecedor: false,
      search: "",
      search_comp: "",
      page: 1,
      dialogPedido: null,
      infoPedido: {
        razao_social: "",
        numero: 0,
        qtdeItens: 0,
        valorTotal: 0,
      },
      pedido: [],
      headersTabelaCarrinho: [
        {
          text: "ID Produto",
          value: "idproduto",
        },
        { text: "Descrição", value: "descricao_produto" },
        {
          text: "Data Solicitação",
          value: "data_solicitacao",
        },
        { text: "Data Previsão", value: "data_previsao" },
        { text: "UM", value: "unidade_medida" },
        { text: "Qtde", value: "qtde" },
        { text: "Qtde.Entregue", value: "qtde_entregue" },
        { text: "Qtde.Pendente", value: "qtde_pendente" },
      ],
      itensTabelaCarrinho: [],
      dialogListaFornecedor: false,
      selectedId: -1,
      headersListaFornecedor: [
        { text: "Código", value: "id" },
        { text: "Razão social", value: "razao_social" },
        { text: "Data da Últ. Análise", value: "data_ultima_analise" },
        { text: "Qtde dias da Últ. Análise", value: "qtde_dias_ultima_analise" },
        { text: "Cotação", value: "cotacao" },
        { text: "Dias em Cotação", value: "dias_em_cotacao" },
        {
          text: "Qtde. Produtos",
          value: "qtde_geral_itens",
        },
        { text: "ABC Venda", value: "abc_venda" },
        { text: "Faturamento Últimos 3 meses (R$ custo)", value: "faturamento_ultimos_tres_meses" },
        { text: "Excesso (R$ custo)", value: "qtde_excesso" },
        {
          text: "Produtos Ok",
          value: "qtde_itens_ok",
        },
        {
          text: "Produtos Ressuprir",
          value: "qtde_itens_ressuprir",
        },
        {
          text: "Produtos Trânsito",
          value: "qtde_itens_transito",
        },
        { text: "Estoque Parado (R$ custo)", value: "estoque_parado" },
        {
          text: "Compra Prevista (Hoje)",
          value: "total_ressuprir",
        },
        {
          text: "",
          value: "icon_compra",
          sortable: false,
        },
      ],
      comprador: {
        codigo: 0,
        nome_completo: "",
      },
      itensListaFornecedor: [],
      dialogListaSegmentosComprador: null,
      itensListaSegmentosComprador: [],
      headersListaSegmentosComprador: [
        { text: "Fornecedor", value: "idfornecedor" },
        { text: "Razão social", value: "razao_social" },
        { text: "Comprador", value: "nome_completo" },
        { text: "Cotação", value: "cotacao" },
        { text: "Dias em Cotação", value: "dias_em_cotacao" },
        { text: "Qtde. Produtos", value: "qtde_geral_itens" },
        { text: "Produtos Ok", value: "qtde_itens_ok" },
        { text: "Produtos Ressuprir", value: "qtde_itens_ressuprir" },
        { text: "Produtos com Venda Futura", value: "qtd_produtos_com_venda_futura" },
        { text: "Produtos Trânsito", value: "qtde_itens_transito" },
        { text: "Compra Prevista (Hoje)", value: "total_ressuprir" },
        { text: "", value: "icon_compra", sortable: false },
      ].filter(item => {
        return item.value !== 'qtd_produtos_com_venda_futura'
          || localStorage.existe_produtos_com_venda_futura === 'S';
      }),
      segmento: {
        codigo: 0,
        nome_completo: "",
      },

      cardsDialogRelatorios: {
        produtosTotal: {
          titulo: "Relatório de Quantidade Produtos Total",
          ativo: false,
          headers: [
            {text: "Id segmento", value: "idfamilia_produto"},
            { text: "Nome segmento", value: "descricao_familia_produto" },
            {
              text: "Id Produto",
              value: "idproduto",
            },
            { text: "Cód. Fornecedor", value: "cod_produto", align: "center" },
            { text: "Descrição Produto", value: "descricao_produto" },
            {text: "Cód. barra", value: "codigo_barras"},
            {
              text: "Unidade Compra",
              value: "unidade_compra",
            },
            {
              text: "Estoque",
              value: "estoque",
            },
            {
              text: "Estoque Segurança",
              value: "estoque_seguranca",
            },
            {
              text: "Ponto Pedido",
              value: "ponto_pedido",
            },
            {
              text: "Estoque Máximo",
              value: "estoque_maximo",
            },
            {
              text: "Cobertura Estoque",
              value: "cobertura_estoque",
            },
            {
              text: "Projeção de vendas",
              value: "consumo_medio_mensal",
            },
          ],
          itens: [],
          familia_produto: 0,
          comprador: 0,
          fornecedor: 0,
          grupo_de_analise: false,
          info: "",
          metodo: 1,
        },
        produtosExcesso: {
          titulo: "Relatório de Produtos em Excesso",
          ativo: false,
          headers: [
            {text: "Id segmento", value: "idfamilia_produto"},
            { text: "Nome segmento", value: "descricao_familia_produto" },
            {text: "Id Produto", value: "idproduto"},
            { text: "Cód. Fornecedor", value: "cod_produto", align: "center" },
            { text: "Descrição Produto", value: "descricao_produto" },
            {text: "Cód. barra", value: "codigo_barras"},
            {
              text: "Unidade Compra",
              value: "unidade_compra",
            },
            {
              text: "Estoque",
              value: "estoque",
            },
            {
              text: "Estoque Segurança",
              value: "estoque_seguranca",
            },
            {
              text: "Ponto Pedido",
              value: "ponto_pedido",
            },
            {
              text: "Estoque Máximo",
              value: "estoque_maximo",
            },
            {
              text: "Cobertura Estoque",
              value: "cobertura_estoque",
            },
            {
              text: "Projeção de vendas",
              value: "consumo_medio_mensal",
            },
            {
              text: "Estoque Excesso",
              value: "estoque_excesso",
            },
          ],
          itens: [],
          familia_produto: 0,
          comprador: 0,
          fornecedor: 0,
          grupo_de_analise: false,
          info: "",
          metodo: 2,
        },
        produtosOk: {
          titulo: "Relatório de Produtos Ok",
          ativo: false,
          headers: [
            {text: "Id segmento", value: "idfamilia_produto"},
            { text: "Nome segmento", value: "descricao_familia_produto" },
            {
              text: "Id Produto",
              value: "idproduto",
            },
            { text: "Cód. Fornecedor", value: "cod_produto", align: "center" },
            { text: "Descrição Produto", value: "descricao_produto" },
            {text: "Cód. barra", value: "codigo_barras"},
            {
              text: "Unidade Compra",
              value: "unidade_compra",
            },
            {
              text: "Estoque",
              value: "estoque",
            },
            {
              text: "Estoque Segurança",
              value: "estoque_seguranca",
            },
            {
              text: "Ponto Pedido",
              value: "ponto_pedido",
            },
            {
              text: "Estoque Máximo",
              value: "estoque_maximo",
            },
            {
              text: "Cobertura Estoque",
              value: "cobertura_estoque",
            },
            {
              text: "Projeção de vendas",
              value: "consumo_medio_mensal",
            },
          ],
          itens: [],
          familia_produto: 0,
          comprador: 0,
          fornecedor: 0,
          grupo_de_analise: false,
          info: "",
          metodo: 3,
        },
        produtosAComprar: {
          titulo: "Relatório de Produtos a Comprar",
          ativo: false,
          headers: [
            {text: "Id segmento", value: "idfamilia_produto"},
            { text: "Nome segmento", value: "descricao_familia_produto" },
            { text: "Tipo Compra", value: "tipo_compra" },
            { text: "Id Produto", value: "idproduto", align: "center" },
            { text: "Cód. Fornecedor", value: "cod_produto", align: "center" },
            { text: "Descrição Produto", value: "descricao_produto" },
            {text: "Cód. barra", value: "codigo_barras"},
            {
              text: "Unidade Compra",
              value: "unidade_compra",
            },
            { text: "Estoque", value: "estoque", align: "center" },
            { text: "Sugestão", value: "sugestao", align: "center" },
            { text: "Status Compra", value: "status_compra" },
          ],
          itens: [],
          familia_produto: 0,
          comprador: 0,
          fornecedor: 0,
          grupo_de_analise: false,
          info: "",
          metodo: 4,
        },
        produtosEmTransito: {
          titulo: "Relatório de Produtos em Trânsito",
          ativo: false,
          headers: [
            {text: "Id segmento", value: "idfamilia_produto"},
            { text: "Nome segmento", value: "descricao_familia_produto" },
            {
              text: "Id Produto",
              value: "idproduto",
            },
            { text: "Cód. Fornecedor", value: "cod_produto", align: "center" },
            { text: "Descrição Produto", value: "descricao_produto" },
            {text: "Cód. barra", value: "codigo_barras"},
            {
              text: "Unidade Compra",
              value: "unidade_compra",
            },
            {
              text: "Estoque",
              value: "estoque",
            },
            {
              text: "Estoque Segurança",
              value: "estoque_seguranca",
            },
            {
              text: "Ponto Pedido",
              value: "ponto_pedido",
            },
            {
              text: "Estoque Máximo",
              value: "estoque_maximo",
            },
            {
              text: "Cobertura Estoque",
              value: "cobertura_estoque",
            },
            {
              text: "Projeção de vendas",
              value: "consumo_medio_mensal",
            },
            {
              text: "Em Trânsito",
              value: "compra_transito",
            },
          ],
          itens: [],
          familia_produto: 0,
          comprador: 0,
          fornecedor: 0,
          grupo_de_analise: false,
          info: "",
          metodo: 5,
        },
        produtosStatusPercepcao: {
          titulo: "Relatório de Status Percepção",
          ativo: false,
          headers: [
            { text: "Ordem Compra", value: "ordem_compra" },
            { text: "Data Solicitação", value: "data_solicitacao" },
            { text: "Id Fornecedor", value: "idfornecedor" },
            { text: "Razão Social", value: "descricao_fornecedor" },
            { text: "Id Produto", value: "idproduto" },
            { text: "Descrição Produto", value: "descricao_produto" },
            { text: "Unid. Medida", value: "unidade_medida" },
            { text: "Estoque Solicitado", value: "estoque_solicitacao" },
            { text: "Qtde. Pedido", value: "qtde_pedido" },
          ],
          itens: [],
          filtros: {
            comprador: 0,
            status_percepcao: "",
          },
          info: "",
          url: "relatorio_produtos_percepcao_compra",
          metodo: 10,
        },
      },
      cardRelatoriosSelecionado: {},
      dialogGrid: false,
      visaoDashboard: 0,
      visao_gerencial: "N",
      dialogEficienciaComprador: false,
      eficiencia: {
        geral: [],
        comprador: [],
      },
      coresStatusPercepcao: [
        "#FFBF00",
        "#042666",
        "#04B431",
        "#FF0000",
        "#0101DF",
        "#000000",
      ],
      dataPointIndex: {},
      categoriesNivelPercepcao: [
        "PERCEPCAO COM ELEVADA EXPOSICAO RUPTURA",
        "PERCEPCAO COM ELEVADA PREMATURIDADE",
        "PERCEPCAO EM PONTO DE PEDIDO",
        "PERCEPCAO EM RUPTURA",
        "PRIMEIRA COMPRA",
        "SEM COMPORTAMENTO",
      ],
      moneMes: [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro", '', ''
      ],
      fornecedores_selecionado: [],
      tela_cheia: false
    };
  },

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
      items: "tabela/getItems",
      grupos: "usuario/getGrupos",
    }),

    ITENS_COMPUTADOS() {
      if (!this.$store.state.tabela.items.data) {
        return [];
      }

      if (this.cardSelecionado.titulo === "Análise de Fornecedores") {
        return this.$store.state.tabela.items.data.filter((item) => item.grupo_analise_fornecedores === this.ativar_exibicao_grupo_fornecedor);
      }

      return this.$store.state.tabela.items.data;
    },
    HEADERS_COMPUTED() {
      return this.cardSelecionado
        .headers[this.indexHeader()]
        .filter(item => {
          return item.value !== 'qtd_produtos_com_venda_futura'
            || localStorage.existe_produtos_com_venda_futura === 'S';
        });
    }
  },

  created() {
    this.page = 1;
    this.cardSelecionado.metodo(this.page, this.grupoCompra);
    this.setVisaoDashboard();
    this.visao_gerencial = this.getVisaoGerencial();
  },

  watch: {
    page: function (novaPage) {
      this.cardSelecionado.metodo(novaPage, this.grupoCompra);
    },
    cardSelecionado: function () {
      this.page = 1;
      this.cardSelecionado.metodo(this.page, this.grupoCompra);
    },
    grupoCompra: function () {
      this.page = 1;
      this.cardSelecionado.metodo(this.page, this.grupoCompra);
      this.setVisaoDashboard();
    },
    dataPointIndex: function () {
      if (this.dataPointIndex.categorie > -1) {
        this.dialogStatusPercepcaoChart();
      }
    },
  },
  methods: {
    deParaClassificacaoCriticidade(valor) {
      const tipo = {
        'Z - VITAL': 'A - VITAL',
        'Y - INTERMEDIARIO': 'B - INTERMEDIARIO',
        'X - ORDINARIO': 'C - ORDINARIO',
      };

      return tipo[valor];
    },

    exportarParaExcel() {
      const comprador = this.$store.getters['usuario/getComprador'];

      const params = `?grupo=${this.grupoCompra}
        &visao_dashboard=${this.visaoDashboard}
        &ativar_exibicao_grupo_fornecedor=${this.ativar_exibicao_grupo_fornecedor ? 'S' : 'N'}
        &idcomprador=${comprador.id ? comprador.id : 0}
        &id_usuario=${localStorage.id}`;

      window.open($axios.defaults.baseURL + this.cardSelecionado.url_exportacao + params, "_blank");
    },
    corItemFornecedorAtivo(item) {
      const { ativo } = item;
      if (ativo && ativo === 'N') {
        return "tr-color-red";
      } else {
        return "";
      }
    },

    exibirIconMudarVisao() {
      return (
        this.visao_gerencial === "S" && this.cardSelecionado.headers.length > 1
      );
    },

    mudarVisaoDashboard() {
      if (this.visaoDashboard == 2) {
        this.visaoDashboard = 1;
      } else {
        this.visaoDashboard = 2;
      }
    },

    dialogStatusPercepcaoChart() {
      let card = this.cardsDialogRelatorios.produtosStatusPercepcao;

      card.ativo = true;

      const grupo = this.grupos.filter((grupo) => grupo.id == this.grupoCompra);

      let info = "Grupo: ".concat(grupo[0].sigla);

      if (this.dataPointIndex.ativar_filtro_comprador) {
        info = info.concat(" / ");
        info = info.concat(this.comprador.codigo);
        info = info.concat("-");
        info = info.concat(this.comprador.nome_completo);

        card.filtros.comprador = this.comprador.codigo;
      } else {
        card.filtros.comprador = -1;
      }

      info = info.concat(" / ");
      info = info.concat(
        this.categoriesNivelPercepcao[this.dataPointIndex.categorie]
      );

      card.info = info;
      card.filtros.status_percepcao = this.categoriesNivelPercepcao[
        this.dataPointIndex.categorie
        ];

      this.cardRelatoriosSelecionado = card;
    },

    fecharDialogEficienciaComprador() {
      this.dialogEficienciaComprador = false;
      this.comprador.codigo = "";
      this.comprador.nome_completo = "";
    },
    buscarEficienciaComprador(item) {
      const headers = this.Helpers.iniciarRequisicao();

      this.comprador.codigo = item.id;
      this.comprador.nome_completo = item.nome_completo;

      const params = {
        grupo: this.grupoCompra,
        comprador: item.id,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getEficienciaComprador(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.eficiencia = response.data.eficiencia;

            this.eficiencia.column.geral["title"] = "Ocorrências do Grupo";
            this.eficiencia.column.comprador["title"] =
              "Ocorrências do Comprador";

            this.eficiencia.colors = ["#043554", "#2E64FE"];

            this.dialogEficienciaComprador = true;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    getVisaoGerencial() {
      return localStorage.getItem("visao_gerencial");
    },

    indexHeader() {
      let i = 0;

      if (
        this.cardSelecionado.multHeaders &&
        this.visao_gerencial == "S" &&
        this.visaoDashboard > 0 &&
        this.visaoDashboard < 3
      ) {
        i = this.visaoDashboard - 1;
      }

      return parseInt(i);
    },

    setVisaoDashboard() {
      this.grupos.forEach((g) => {
        if (g.id == this.grupoCompra) this.visaoDashboard = g.visao_dashboard;
      });
    },

    verificaExistencia(titulo) {
      return this.HEADERS_COMPUTED.some((t) => String(t.value) === String(titulo));
    },

    sumField(key, dados = this.items.data || []) {
      return Object.values(dados).reduce((a, b) => {
        if (b.grupo_analise_fornecedores) {
          return parseFloat(a);
        }

        return parseFloat(a) + parseFloat(b[key] || 0);
      }, 0);
    },

    enviarDadosParaDialogRelatorio(card, item) {
      card.grupo_de_analise = undefined;

      if (item.idfamilia_produto !== undefined) {
        card.familia_produto = item.idfamilia_produto;
        card.comprador = '';
        card.fornecedor = '';
      } else if (item.nome_completo !== undefined) {
        card.comprador = item.id;
        card.familia_produto = '';
        card.fornecedor = '';
      } else if (item.id !== undefined) {
        card.fornecedor = item.id;
        card.comprador = '';
        card.familia_produto = '';

        if (item.grupo_analise_fornecedores) {
          card.grupo_de_analise = true;
        }
      }

      this.cardRelatoriosSelecionado = card;
    },

    activerow(item) {
      this.selectedId = item.id;
      this.$set(item, "selected", true);
    },

    getSegmentoComprador(item, tipo = 1) {
      let data = {
        id: item.idcomprador,
        nome_completo: item.nome_completo,
      };

      item.descricao_segmento = this.segmento.nome_completo;

      this.$store.dispatch("fornecedor/setComprador", data);
      this.activerow(item);
      this.Helpers.buscarCompraFornecedorSegmento(item, tipo);
    },

    getFornComprador(item, tipo = 1) {
      this.activerow(item);

      if (item.grupo_analise_fornecedores) {
        localStorage.analiseGrupoFornecedores = 'S';
      } else {
        localStorage.analiseGrupoFornecedores = 'N';
      }

      this.Helpers.buscarCompraFornecedor(item, tipo);
    },

    getFornListaCompradorGrupo(item) {
      this.dialogListaFornecedor = true;
      this.itensListaFornecedor = [];

      this.$store.dispatch("fornecedor/setComprador", item);

      this.comprador.codigo = item.id;
      this.comprador.nome_completo = item.nome_completo;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        comprador: item.id,
        grupo: this.grupoCompra,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getListaFornecedoresComptadorTabelaGrupo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              response.data.fornecedores.forEach((fornecedor) => {
                fornecedor.icon_compra = "mdi-cart";
              });

              this.itensListaFornecedor = response.data.fornecedores;

              if (this.itensListaFornecedor.length) {
                this.itensListaFornecedor.forEach((item) => {
                  item.qtde = this.Helpers.formatarValor(item.qtde);
                  item.qtde_pendente = this.Helpers.formatarValor(
                    item.qtde_pendente
                  );
                  item.qtde_entregue = this.Helpers.formatarValor(
                    item.qtde_entregue
                  );
                  item.qtde_itens_transito = this.Helpers.formatarValor(
                    item.qtde_itens_transito
                  );
                });
              }
            } else {
              this.itensListaFornecedor = [];
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    getListaSegmentosComprador(item) {
      this.dialogListaSegmentosComprador = true;
      this.itensListaSegmentosComprador = [];

      this.segmento.codigo = item.idfamilia_produto;
      this.segmento.nome_completo = item.descricao_familia_produto;

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
        categoria: item.idfamilia_produto,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        DashboardAPI.getListaSegmentosComprador(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            let id = 0;

            if (response.status == 200) {
              response.data.segmentos.forEach((categoria) => {
                id++;
                categoria.id = id;
                categoria.icon_compra = "mdi-cart";
              });

              this.itensListaSegmentosComprador = response.data.segmentos;
            } else {
              this.itensListaSegmentosComprador = [];
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    getPedido(pedido) {
      this.dialogPedido = true;

      this.infoPedido.razao_social = pedido.razao_social;
      this.infoPedido.numero = pedido.id_solicitacao;

      this.itensTabelaCarrinho = [];

      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        pedido: pedido.id_solicitacao,
        fornecedor: pedido.id,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getPedidoGrupo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.pedido = response.data.pedido;

              if (this.pedido.length) {
                this.infoPedido.qtdeItens = this.pedido[0].total_itens;
                this.infoPedido.valorTotal = this.pedido[0].total;
              }

              this.itensTabelaCarrinho = response.data.itens;
            } else {
              this.itensTabelaCarrinho = [];
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    exportarDadosGrid() {
      let url = "relatorio_exportacao_grid?";

      if (this.verificaExistencia("icon_compra")) {
        url += "card=1"; //fornecedor
      } else if (this.verificaExistencia("icon_analise_segmentos")) {
        url += "card=2"; //segmento
      } else if (this.verificaExistencia("nome_completo")) {
        url += "card=3"; //comprador
      } else if (this.verificaExistencia("id_solicitacao")) {
        url += "card=4"; //pedidos
      } else {
        url += "card=5"; //produtos
      }

      url += "&grupo=" + this.grupoCompra;

      window.open($axios.defaults.baseURL + "/" + url, "_blank");
    },
    exportarFornecedoresEmRessuprimento() {
      const params = `grupo/${this.grupoCompra}/comprador/${this.comprador.codigo}`;

      window.open(`${$axios.defaults.baseURL}/reports/fornecedores-em-ressuprimento/${params}`, "_blank");
    }
  },
};
</script>
<style scoped lang="scss">
.dot {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
}
.alerta td {
  color: red;
}

@media (max-height: 90000px) {
  .altura-grafico-eficiencia {
    height: 350px;
  }
}
@media (max-height: 850px) {
  .altura-grafico-eficiencia {
    height: 335px;
  }
}
@media (max-height: 800px) {
  .altura-grafico-eficiencia {
    height: 325px;
  }
}
@media (max-height: 750px) {
  .altura-grafico-eficiencia {
    height: 305px;
  }
}
@media (max-height: 700px) {
  .altura-grafico-eficiencia {
    height: 280px;
  }
}
@media (max-height: 650px) {
  .altura-grafico-eficiencia {
    height: 260px;
  }
}
@media (max-height: 600px) {
  .altura-grafico-eficiencia {
    height: 240px;
  }
}
</style>

<style>
/*
**   ALTURA DINAMICA EM DIFERENTES TAMANHOS DE TELAS
*/

.altura-responsiva-grid-principal .v-data-table__wrapper {
  height: calc(100vh - 440px) !important;
}

.altura-responsiva-grid-fullscreen .v-data-table__wrapper {
  height: calc(100vh - 190px) !important;
}

.altura-responsiva-grid-principal .v-data-table__wrapper,
.altura-responsiva-grid-fullscreen .v-data-table__wrapper {
  overflow: auto !important;
}

.gridPrincipal .v-data-table__wrapper table thead tr th {
  vertical-align: top !important;
}
.totalizadores th {
  padding-left: 5px !important;
  padding-right: 15px !important;
}
.tr-color-red .text-start{
  color: #ff0000;
}
</style>
